/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ChangeRequestOrderBy,
  ChangeRequestStatus,
  ChangeRequestSubject,
  EntityId,
  JSONDocument,
  List,
  SiteChangeRequest,
  SiteChangeRequestMemberStatus,
} from "./data-contracts";

/**
 * @description Returns a paginated list of change requests reviewing the site. A site change request groups changes to the site structure and to any number of its spaces into one review. Use this to discover existing change requests before creating a new one.
 * @tags site-change-requests
 * @name ListChangeRequestsForSite
 * @summary List all change requests for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/change-requests
 * @secure
 */

// @ts-ignore
export const listChangeRequestsForSite: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If defined, only change requests matching this status will be returned.
     * @default "open"
     */
    status?: ChangeRequestStatus;
    /** If defined, only change requests created by this user will be returned. */
    createdBy?: string;
    /** If defined, only change requests moved out of draft by this user will be returned. */
    openedBy?: string;
    /** If defined, only change requests archived by this user will be returned. */
    archivedBy?: string;
    /** If defined, only change requests merged by this user will be returned. */
    mergedBy?: string;
    /** If defined, only change requests with contributions from this user will be returned. */
    contributor?: string;
    /**
     * Status of the members.
     * @default "active"
     */
    memberStatus?: SiteChangeRequestMemberStatus;
    /** The field to sort change requests by. Defaults to 'updatedAt'. */
    orderBy?: ChangeRequestOrderBy;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteChangeRequest[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/change-requests",
  method: "get",
  streaming: false,
  tags: ["site-change-requests"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a change request reviewing the site, as a draft working copy of the content of the spaces it changes. It starts with no members: a space becomes one on its first edit.
 * @tags site-change-requests
 * @name CreateSiteChangeRequest
 * @summary Create a new change request in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/change-requests
 * @secure
 */

// @ts-ignore
export const createSiteChangeRequest: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Subject of the change request */
    subject?: ChangeRequestSubject;
    description?: JSONDocument;
  };
  RequestHeaders: {};
  ResponseBody: SiteChangeRequest;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/change-requests",
  method: "post",
  streaming: false,
  tags: ["site-change-requests"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a single site change request, including its status, subject, description, aggregate version and active members. Use this to check its current state before deciding to merge, update or request a review.
 * @tags site-change-requests
 * @name GetSiteChangeRequestById
 * @summary Get a site change request by its ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}
 * @secure
 */

// @ts-ignore
export const getSiteChangeRequestById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the change request or its number identifier in the site */
    changeRequestId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteChangeRequest;
  ResponseStatusCode: 200 | 404;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}",
  method: "get",
  streaming: false,
  tags: ["site-change-requests"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates the metadata of a site change request. Use this to rename it, add context before requesting a review, or change its workflow status without merging. To change the resources it reviews, update its members instead.
 * @tags site-change-requests
 * @name UpdateSiteChangeRequestById
 * @summary Update a site change request's subject, description, or status
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}
 * @secure
 */

// @ts-ignore
export const updateSiteChangeRequestById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the change request or its number identifier in the site */
    changeRequestId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Subject of the change request */
    subject?: ChangeRequestSubject;
    description?: JSONDocument;
    status?: "draft" | "open" | "archived";
  };
  RequestHeaders: {};
  ResponseBody: SiteChangeRequest;
  ResponseStatusCode: 200 | 404 | 409;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}",
  method: "patch",
  streaming: false,
  tags: ["site-change-requests"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Permanently deletes a change request and its members. Merged change requests cannot be deleted; archive a change request instead to keep its review history.
 * @tags site-change-requests
 * @name DeleteSiteChangeRequestById
 * @summary Delete a site change request
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}
 * @secure
 */

// @ts-ignore
export const deleteSiteChangeRequestById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique ID of the change request or its number identifier in the site */
    changeRequestId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 409;
} = {
  route:
    "/orgs/{organizationId}/sites/{siteId}/change-requests/{changeRequestId}",
  method: "delete",
  streaming: false,
  tags: ["site-change-requests"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
